// checkout.tsx
import React, { useState, useEffect } from "react";
import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { useDispatch } from "react-redux";
import { CheckoutFormProps } from "../interfaces/Payment";



const CheckoutForm: React.FC<CheckoutFormProps> = ({ programId, clientSecret,title,icon,cost,date }) => {
  const dispatch = useDispatch();
  const stripe = useStripe();
  const elements = useElements();

  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!stripe) {
      return;
    }

    // Make sure paymentIntent is defined before accessing its properties
    stripe.retrievePaymentIntent(clientSecret).then((result) => {
      const paymentIntent = result?.paymentIntent;

      if (paymentIntent) {
        switch (paymentIntent.status) {
          case "succeeded":
            setMessage("Payment succeeded!");
            break;
          case "processing":
            setMessage("Your payment is processing.");
            break;
          case "requires_payment_method":
            setMessage("Your payment was not successful, please try again.");
            break;
          default:
            setMessage("");
            break;
        }
      } else {
        setMessage("Payment intent not found.");
      }
    });
  }, [stripe, clientSecret]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
  
    if (!stripe || !elements) {
      return;
    }
  
    setIsLoading(true);
  
    const { error } = await stripe.confirmPayment({
      elements,
      confirmParams: {
        return_url: `${window.location.origin}/thankyou`,
      },
    });
  
    if (error?.type === "card_error" || error?.type === "validation_error") {
      setMessage(error.message || "An unexpected error occurred."); // Use error.message or a default message
    } else {
      setMessage("An unexpected error occurred.");
    }
  
    setIsLoading(false);
  };

  const paymentElementOptions = {
    layout: "tabs",
  };

  return (
    <>
      <div className="relative">
        <div
          className="bg-cover bg-center text-center text-white p-8"
          style={{
            backgroundImage: `url("./images/innerb.jpg")`,
          }}
        >
          <div className="text-center pt-40 pb-28">
            <h1 className="text-2xl md:text-4xl font-bold">Checkout</h1>
          </div>
        </div>
      </div>
      <div className="container  m-auto">
      <div className="flex flex-col md:flex-row ">
        <div  className="basis-4/12 py-12">
          <p className="text-3xl  mb-4 font-semibold">Program details</p>
       <div className="detail flex">    

          <img
              src={icon}
              alt="title"
              className="w-24 h-28   object-cover"
            /> 
          <div className="flex flex-col py-2 px-6">
              <h2 className="text-2xl mb-1 font-semibold">{title}</h2>
              <p className="text-lg">{date}</p>
              <p className="text-lg my-1 mb-4">${cost}</p>
            </div>        
          </div>
          
        </div>
        <div className="basis-1/2 m-auto">
        <form id="payment-form" onSubmit={handleSubmit} className="my-12 m-auto">
          <PaymentElement id="payment-element" options={paymentElementOptions as any} />
          <button disabled={isLoading || !stripe || !elements} id="submit" className="mt-6 text-white bg-[#B4804A] px-8 uppercase font-semibold rounded-lg py-3 pl-7">
            <span id="button-text">
              {isLoading ? <div className="spinner" id="spinner"></div> : "Pay now"}
            </span>
          </button>
          {message && <div id="payment-message">{message}</div>}
        </form>
        </div>
        </div>
      </div>
    </>
  );
};

export default CheckoutForm;
